export const PerformanceInsightsPermissions = {
  ViewAgentPerformance: {
    permissionsId: "d3551d83-d855-4eec-93f6-161ad6070dea",
    permissionsName: "View Agent Performance",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewCampaignPerformance: {
    permissionsId: "c3464643-c03d-49ea-84de-8622e8272aab",
    permissionsName: "View Campaign Performance",
    description: null,
    componentsId: null,
    components: null,
  },
};
